module.exports = function negotiateDates(event, comparedEvent) {
    if(event.isActual) {
        comparedEvent.isActual = true;
        comparedEvent.time = event.time;
        comparedEvent.date = event.date;
        comparedEvent.ticks = event.ticks;
    }
}
